// extracted by mini-css-extract-plugin
export var container = "MobileDrawer_container__yO3iF";
export var content = "MobileDrawer_content__Oyc-N";
export var drawerHandle = "MobileDrawer_drawerHandle__Q6-6O";
export var modal = "MobileDrawer_modal__Sk4Lc";
export var popUpwards = "MobileDrawer_popUpwards__GwtSw";
export var swipeDown = "MobileDrawer_swipeDown__tO32K";
export var swipedDown = "MobileDrawer_swipedDown__k4uFp";